/* Vokshus: ankra "Mere"-dropdownen precis under knappen.
   Horizon lägger overflow-panelen i full sidbredd; CSS i _header-menu.liquid
   gör den till en liten meny och läser --vk-more-left / --vk-more-right härifrån.
   Faller tyst tillbaka till högerkanten om något saknas. */
(function () {
  'use strict';

  var PANEL_WIDTH = 260;
  var EDGE_MARGIN = 16;

  function placeOne(menu) {
    var more = menu.querySelector('[slot="more"]');
    if (!more || !more.getBoundingClientRect) return;

    var menuRect = menu.getBoundingClientRect();
    var moreRect = more.getBoundingClientRect();
    if (!moreRect.width) return;

    var fitsLeftAligned = moreRect.left + PANEL_WIDTH < window.innerWidth - EDGE_MARGIN;

    if (fitsLeftAligned) {
      menu.style.setProperty('--vk-more-left', moreRect.left - menuRect.left + 'px');
      menu.style.setProperty('--vk-more-right', 'auto');
    } else {
      menu.style.setProperty('--vk-more-left', 'auto');
      menu.style.setProperty('--vk-more-right', menuRect.right - moreRect.right + 'px');
    }
  }

  function placeAll() {
    var menus = document.querySelectorAll('.overflow-menu');
    for (var i = 0; i < menus.length; i++) placeOne(menus[i]);
  }

  var pending = null;
  function schedule() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(placeAll, 100);
  }

  function init() {
    placeAll();
    window.addEventListener('resize', schedule);
    document.addEventListener('pointerover', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('.overflow-menu')) placeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Publicerat kökssortiment: vanlig länk även när kundvyn byter intern sida. */
(function () {
  'use strict';
  var labels = { nb: 'Kjøkken', en: 'Kitchen', sv: 'Köket', da: 'Køkken', de: 'Küche', nl: 'Keuken', fr: 'Cuisine' };
  var pending = false;
  function update() {
    pending = false;
    var chooser = document.querySelector('.language-selector select');
    var lang = chooser && chooser.value || document.documentElement.lang.split('-')[0];
    if (!labels[lang]) lang = 'nb';
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root) {
      var prefix = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/);
      root = prefix ? '/' + prefix[1] + '/' : '/';
    }
    var url = root.replace(/\/$/, '') + '/collections/vokshus-kjokken';
    var menus = document.querySelectorAll('.site-header nav.nav, nav.filter-nav, header-component nav.vk-wax-entry');
    for (var i = 0; i < menus.length; i++) {
      if (menus[i].classList.contains('vk-wax-entry')) {
        menus[i].style.display = 'flex';
        menus[i].style.justifyContent = 'center';
        menus[i].style.flexWrap = 'wrap';
        var categoryLabels = {nb:'Produktkategorier',en:'Product categories',sv:'Produktkategorier',da:'Produktkategorier',de:'Produktkategorien',nl:'Productcategorieën',fr:'Catégories de produits'};
        menus[i].setAttribute('aria-label', categoryLabels[lang]);
      }
      var link = menus[i].querySelector('[data-vk-kitchen-link]');
      if (link && link.hasAttribute('data-vk-kitchen-static')) continue;
      if (!link) {
        link = document.createElement('a');
        link.setAttribute('data-vk-kitchen-link', '');
        menus[i].appendChild(link);
      }
      if (link.getAttribute('href') !== url) link.setAttribute('href', url);
      if (link.textContent !== labels[lang]) link.textContent = labels[lang];
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(update);
    else window.setTimeout(update, 0);
  }
  function init() {
    update();
    document.addEventListener('change', schedule);
    if (window.MutationObserver) {
      var observer = new MutationObserver(schedule);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
